import React from 'react'
import styled from 'styled-components'

import { Combinable } from '../Combinable/Combinable'
import { DayLengthText } from '../DayLengthText/DayLengthText'

type DayLengthProps = {
  day_length?: 'FULL' | 'HALF_AM' | 'HALF_PM' | 'OVERNIGHT' | null
  half_day_combinable?: boolean
  id?: number
}

export const DayLengthCampSearchPage: React.FC<DayLengthProps> = ({ day_length, half_day_combinable, id = 0 }) => {
  return (
    <DayLengthWrapper>
      <DayLengthText day_length={day_length} />
      <span data-testid={`half-day-combinable-camp-id-${id}`}>
        <Combinable show={half_day_combinable} testId={`combinable-tooltip-camp-id-${id}`} />
      </span>
    </DayLengthWrapper>
  )
}

const DayLengthWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.25rem;
`
